import React, { Component } from "react";
import Kiosko from "../../../components/Kiosko/Kiosko";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : KioskoForm
Description : Compoente que alberga el formulario de Kiosko definido en el directorio de componentes
Date Autor Modification
================================================================================
29/09/2022 Santiago Coca - Se define el componente
================================================================================ */

class KioskoForm extends Component {
    render() {
        return (
            <Kiosko />
        )
    }
}

export default KioskoForm;